import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import PreviewRoute from "../main/PreviewRoute";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const RedirectRoute = () => {
  const query = useQuery();
  const doc_id = query.get("doc_id");
  const txn_id = query.get("txn_id");

  const props = {
    main: "manage",
    mainfilter: "0",
    pop: "preview",
    popfilter: doc_id,
    txn_id: txn_id,
  };

  return <PreviewRoute params={props} />;
};

export default RedirectRoute;
